import {useSearchParams} from "react-router-dom";
import React from "react";
import {AllProductComponent} from "./AllProductComponent";

export default function AllProductProvider() {
    const [searchParams, setSearchParams] = useSearchParams();

    const marketId = searchParams.get('market_id');
    const categoryId = searchParams.get('category_id');
    const tableId = searchParams.get('table_id');

    return <AllProductComponent market_id={marketId} child_category_id={categoryId} table_id={tableId}/>
}
